export default {
  label: {
    noLogoSelected: 'Nenhum logo selecionado',
    logoTitle: 'Link da imagem do cabeçalho',
    colorTitle: 'Cor do cabeçalho',
    themeTitle: 'Tema',
    clearColor: 'Limpar cor',
    themeSwitch: 'Tema escuro',
  },
};
